module.exports = __webpack_public_path__ + "assets/img/5874-tv.svg";